import { logout, store } from "@redux";
import axios, { AxiosHeaders } from "axios";
import queryString from "query-string";
import { normalizeApiError } from "@utils/apiError";

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,

  headers: {
    "Content-Type": "application/json",
  },
  paramsSerializer: {
    serialize: (params) => queryString.stringify(params),
  },
});

axiosClient.interceptors.request.use((config) => {
  const token = store.getState()?.auth?.auth?.token || store.getState()?.app?.temp || "";
  config.headers = config.headers ?? ({} as AxiosHeaders);
  if (token) {
    // @ts-ignore
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: any) => {
    if (error?.response?.status === 403) {
      await store.dispatch(logout());
      window.location.href = "/login";
    }

    return Promise.reject(normalizeApiError(error));
  }
);

export default axiosClient;
